import React from 'react';
import { Button } from './Button';
import { ArrowRight } from 'lucide-react';
import { useModal } from './ModalContext';
export const CallToAction = () => {
  const {
    openTalkToUs
  } = useModal();
  return <section id="cta" className="w-full bg-white py-section-mobile md:py-section-desktop relative overflow-hidden" data-id="element-47" data-mp="14c6s3hp6sbvu">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48" data-mp="198x3hrq1qjax">
        <div className="max-w-6xl mx-auto" data-id="element-49" data-mp="ucy02udvt7c4">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-20 items-center" data-id="element-50" data-mp="ubwfnzaz78hq">
            <div className="lg:col-span-12" data-id="element-51" data-mp="zd3om1ouudpz"></div>
            <div className="lg:col-span-12" data-id="element-52" data-mp="lcst2lcloayh">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3KFpKL4x8ZRHY6kZ6KEr1H/image.png" alt="Decorative divider with plant illustrations" className="w-full mx-auto mb-8" data-id="element-53" data-mp="lduenjr8sfug" />
              <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-2xl shadow-glow p-6 md:p-10 lg:p-12 space-y-5 border border-primary-100 transition-all duration-300 hover:shadow-glow-hover backdrop-blur-sm lg:max-w-[80%] lg:mx-auto" data-id="element-54" data-mp="2kpde97qnobrg">
                <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-cyan-800 leading-tight text-center" data-id="element-55" data-mp="25vgybjz1gbv2">
                  Bring Nisa to your school or district
                </h2>
                <div className="space-y-3 max-w-xl mx-auto" data-id="element-56" data-mp="2ep2dv5j11x5j">
                  <p className="text-base md:text-lg text-gray-600 leading-relaxed text-center" data-id="element-57" data-mp="1qxy2xyruv0en">
                    Request a walkthrough to learn how Nisa can strengthen
                    coaching in your school or district.
                  </p>
                  <p className="text-center" data-id="element-58" data-mp="20usyq9wqump8">
                    <a href="/schools" className="text-base text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors duration-200" data-id="element-59" data-mp="1vxjauyp06j3i">
                      Learn how Nisa works for schools and districts
                    </a>
                  </p>
                </div>
                <div className="flex justify-center pt-1" data-id="element-60" data-mp="3fg09ko3dmb71">
                  <Button type="button" size="lg" onClick={openTalkToUs} data-id="element-61" data-mp="3jdxzjt4z11bh">
                    Request a Nisa demo
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};